export default "__VITE_ASSET__BqRe1N9G__"